import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import Message from 'eCoach/_assets/message-icon.png';

// styles
import * as AllChats from 'eCoach/_styles/AllChats.style';
import * as Text from 'theme/components/Text.style';
import { TAB_SLUG, TabSlug } from 'constants/ecoachTabs';

interface EmptyStateProps {
  tab: TabSlug;
}

export default function EmptyState({ tab }: EmptyStateProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');

  const getTitle = () => {
    if (tab === TAB_SLUG.ALL) {
      return t('allChats.EmptyState.allConversationsTitle');
    }
    if (tab === TAB_SLUG.IN_PROGRESS) {
      return t('allChats.EmptyState.inProgressTitle');
    }
    if (tab === TAB_SLUG.RESOLVED) {
      return t('allChats.EmptyState.resolvedTitle');
    }
    if (tab === TAB_SLUG.DRAFTS) {
      return t('allChats.EmptyState.draftsTitle');
    }
    return '';
  };

  const getText = () => {
    if (tab === TAB_SLUG.ALL) {
      return t('allChats.EmptyState.allConversations');
    }
    if (tab === TAB_SLUG.IN_PROGRESS) {
      return t('allChats.EmptyState.inProgress');
    }
    if (tab === TAB_SLUG.RESOLVED) {
      return t('allChats.EmptyState.resolved');
    }
    if (tab === TAB_SLUG.DRAFTS) {
      return t('allChats.EmptyState.drafts');
    }
    return '';
  };

  return (
    <AllChats.EmptyStateContainer>
      <AllChats.EmptyStateIcon src={Message} />
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Text.H6>{getTitle()}</Text.H6>
        <Text.P3>{getText()}</Text.P3>
      </div>
    </AllChats.EmptyStateContainer>
  );
}
